import { useCompactPortrait, useNavigationAction } from './NavigationContext';

export default function RightSidebar({ label, icon = 'bi-sliders2', open, onClose, panelRef, children, keepOpenOnAction = false }) {
  const compact = useCompactPortrait();
  useNavigationAction('configuration', {
    label,
    icon,
    renderContent: ({ closeMore }) => (
      <div ref={panelRef} className="mobile-sidebar-content" onClick={event => {
        if (event.target.closest('button.right-menu-item')) {
          onClose();
          if (!keepOpenOnAction && !event.target.closest('[data-mobile-modal]')) closeMore();
        }
      }}>
        {children}
      </div>
    ),
  });

  if (compact || !open) return null;
  return (
    <>
      <div className="right-menu-overlay" onClick={onClose} />
      <nav ref={panelRef} className="right-menu-panel">{children}</nav>
    </>
  );
}
